module.exports = __webpack_public_path__ + "static/media/loading24.54d9236a.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading24.png
// module id = 209
// module chunks = 0